import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify';

const initialState = {
  value: 0,
  userData: {},
  allUserData: [],
  count:0,
  loading: false,
  rolesList: [],
  otherUserData: {},
  permission: [],
  userPermission: [],
  userRole: "",
  error: {}
}
export const fetchAllUserData = createAsyncThunk('userSlice/fetchAllUserData', async (queryString, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/users${queryString?queryString : ''}`);
    return response.data; 
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch users');
  }
});
export const fetchCurrentUser = createAsyncThunk('userSlice/fetchCurrentUser', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get('/users/me');
    return response; // Data will be handled by the extraReducers
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch users');
  }
});

export const activeInactive = createAsyncThunk('userSlice/activeInactive', async (data, thunkAPI, userId) => {

  try {
    const response = await axiosInstance.patch(`/users/${data.id}`, { is_active: data.is_active });
    return response; // Data will be handled by the extraReducers
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});
export const deleteUser = createAsyncThunk('userSlice/deleteUser', async (uuid, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/users/${uuid}`);
    response.data = uuid
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});
export const createUser = createAsyncThunk('userSlice/createUser', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.post('/auth/register', values);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const updateUser = createAsyncThunk('userSlice/updateUser', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.patch(`/users/${values?.uuid}`, values);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});
export const updateUserOwnProfile = createAsyncThunk('userSlice/updateUserOwnProfile', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.patch(`/users/me`, values);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    // Handle fetchAllUserData
    builder.addCase(fetchAllUserData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchAllUserData.fulfilled, (state, action) => {
      state.allUserData = action.payload?.data?.results;
      state.count = action.payload?.data?.count;
      state.loading = false;
    });
    builder.addCase(fetchAllUserData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // fetchCurrentUser 
    builder.addCase(fetchCurrentUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchCurrentUser.fulfilled, (state, action) => {
     
      state.userData = action?.payload?.data?.data;
      if (state.userData?.role[0]?.permissions?.assigned_permissions)
        state.userPermission = state.userData?.role[0]?.permissions?.assigned_permissions;
        state.userRole = state.userData?.role[0]?.name;
        state.loading = false;
    });
    builder.addCase(fetchCurrentUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Handle activeInactive
    builder.addCase(activeInactive.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(activeInactive.fulfilled, (state, action) => {
      const updatedUser = action.payload.data.data;
      state.loading = false;
      if (action.payload.status == 200) {
        state.allUserData = state.allUserData.map(user =>
          user.id === updatedUser.id ? updatedUser : user
        );
        toast.success(updatedUser.is_active ? "Activated successfully !" : "User Inactivated !")
      }
      console.log("state.allUserData",state.allUserData);
      
    });
    builder.addCase(activeInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //deleteUser
    builder.addCase(deleteUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      const useruuid = action.payload.data;
      state.loading = false;
      if (action?.payload?.status == 204) {
        toast.success("User Deleted Successfully !")
        state.allUserData = state.allUserData.filter(user => user.uuid !== useruuid);
      }
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //userCreated
    builder.addCase(createUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createUser.fulfilled, (state, action) => {
      const updatedUser = action.payload?.data?.data;
      state.loading = false;
      if (action.payload.status == 201) {
        state.allUserData = [updatedUser, ...state.allUserData]
        toast.success("User created Successfully !")
      }
    });
    builder.addCase(createUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //update user
    builder.addCase(updateUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateUser.fulfilled, (state, action) => {
      const updatedUser = action.payload?.data?.data;
      state.loading = false;
      if (action.payload.status == 200) {
        state.allUserData = state.allUserData.map(user =>
          user.id === updatedUser.id ? updatedUser : user
        );
        toast.success("User updated Successfully !")
      }
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(updateUserOwnProfile.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateUserOwnProfile.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.status == 200) {
        state.userData = action?.payload?.data?.data;
        toast.success("User updated Successfully !")
      }
    });
    builder.addCase(updateUserOwnProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
})

export const { setUserData, setAllUserData, setRolesList, setOtherUserData } = userSlice.actions

export default userSlice.reducer